var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-button',{attrs:{"variant":"link"},on:{"click":function($event){return _vm.setNextPage(_vm.targetPageValue)}}},[_vm._v(_vm._s(_vm.targetPageName))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }